export default {
  SET_REQUEST_ERROR: 'SET_REQUEST_ERROR',
};
